import axios from './common/axios';

export default {
  list(params) {
    return new Promise(function(resolve, reject) {
      axios
        .get('/orders/api', {
          params
        })
        .then(function(res) {
          return resolve(res.data);
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  },

  changeShippingAddress(params) {
    return new Promise(function(resolve, reject) {
      axios
        .post('/orders/change_shipping_address', params)
        .then(function(res) {
          if (res.data.status !== 'success') {
            return reject(res.data.errors);
          }
          return resolve(res.data);
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  },

  // Shipment のキャンセルリクエストを送信する
  cancelShipment(params) {
    const data = {
      order_id: params.order_id,
      shipment_id: params.shipment_id,
      shipmentgroup_id: params.shipmentgroup_id
    };
    return new Promise(function(resolve, reject) {
      axios
        .post('/orders/cancel_shipment', data)
        .then(function(res) {
          if (res.data.status !== 'success') {
            return reject(new Error(res.data.error && res.data.error.msg));
          }
          resolve(res.data);
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  },

  resendDigitalContentGiftEmail(params) {
    return new Promise(function(resolve, reject) {
      axios
        .post('/shop/gift/resending', {
          id: params.id
        })
        .then(function(res) {
          if (res.data.status !== 'ok') {
            return reject();
          }
          return resolve(res.data);
        })
        .catch(function(err) {
          return reject(err);
        });
    });
  }
};
